module.exports = __webpack_public_path__ + "img/team-map-06.6683c66d.png";